import {BASE_PATH_API, TIMEOUT_TIME, STAGE_DIRNAME, BASE_PATH_API_DEV, BASE_PATH_T1, JWT1} from 'constants/general'
import axios from 'axios'
import { decodeStorage } from 'functions/storageBase64'
import { timeNow } from'functions/timeNow'

/* Clientes  */
export async function getClientT1(){
    const profileData = decodeStorage('profileData')
    let token = decodeStorage('access_token')
    let apiURL = null


    if(STAGE_DIRNAME === "dev"){
        apiURL = `${BASE_PATH_API_DEV.verificarCreditoCS}/t1pagos/v2/clients/${profileData?.idClaro}`

    }else{
        apiURL = `${BASE_PATH_API}/t1pagos/v2/clients/${profileData?.idClaro}`
    }

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${token}`
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

export async function postClientT1(){
    const profileData = decodeStorage('profileData')
    let token = decodeStorage('access_token')
    let apiURL = null

    if(STAGE_DIRNAME === "dev"){
        apiURL = `${BASE_PATH_API_DEV?.verificarCreditoCS}/t1pagos/v2/clients`
    }else{
        apiURL = `${BASE_PATH_API}/t1pagos/v2/clients`
    }

    let apellidoMat
    if(profileData.apellidoM === null ){
        apellidoMat = ''
    }else{
        apellidoMat = profileData.apellidoM
    }

    // console.log('apellidoMat: ',apellidoMat)

    const raw = {
        "id_externo": String(profileData?.idClaro),
        "nombre": String(profileData?.nombre),
        "apellido_paterno": String(profileData?.apellidoP),
        "apellido_materno": String(apellidoMat),
        "email": String(profileData?.correo)
    }
    
    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${token}`
        },
        data: raw 
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}


/* Tarjetas  */
export async function getCardsT1(tokenClienteT1){
    const profileData = decodeStorage('profileData')
    let token = decodeStorage('access_token')
    let apiURL = null

    if(STAGE_DIRNAME === "dev"){
        apiURL = `${BASE_PATH_API_DEV.verificarCreditoCS}/t1pagos/v2/clients/${tokenClienteT1}/cards`
    }else{
        apiURL = `${BASE_PATH_API}/t1pagos/v2/clients/${tokenClienteT1}/cards`
    }

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${token}`
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

export async function getDataCardT1(idCard){   
    let apiURL = `${BASE_PATH_T1}/v1/tarjeta/${idCard}`

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${JWT1}`
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

export async function postAddCardT1(dataRaw){
    let apiURL = `${BASE_PATH_T1}/v1/tarjeta`
    let row = dataRaw

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${JWT1}`
        },
        data: row
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

export async function updateCardT1({dataRaw, idCard} = {}){

    let apiURL = `${BASE_PATH_T1}/v1/tarjeta/${idCard}`
    let row = dataRaw

    const config = {
        method: 'put',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${JWT1}`
        },
        data: row
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

export async function deleteCardT1(idCard){
    
    let apiURL = `${BASE_PATH_T1}/v1/tarjeta/${idCard}`

    const config = {
        method: 'delete',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${JWT1}`
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}